import React, { useEffect } from 'react';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { VovClient } from '../../../../ApiOld/ApiServerVov';
import { useMobileApi } from '../../../../Api/Mobile/useMobileApi';
import { RequestResponseDTOState, RequestResponseWithBuildingDTO, SetRequestStateEmployeeMobileRequest, TodoState } from '../../../../ApiOld/Api/ApiServerVov';
import { CalendarMonth, Close, Info, Person } from '@mui/icons-material';
import { useEmployeeContext } from '../../../../Contexts/Providers/EmployeeLayoutProvider';

interface MobileRequestItemUpperMenuProps {
    request: RequestResponseWithBuildingDTO;
    setRequest: React.Dispatch<React.SetStateAction<RequestResponseWithBuildingDTO | undefined>>;
}

const MobileRequestItemUpperMenu: React.FC<MobileRequestItemUpperMenuProps> = ({ request, setRequest }) => {
    const { t, i18n } = useTranslation();
    const { authorizedMobileEmployeeApi } = useMobileApi(VovClient);
    const { employeeInfo, setModuleSecondButton } = useEmployeeContext();
    const [detailOpen, setDetailOpen] = React.useState(false);

    useEffect(() => {
        setModuleSecondButton && setModuleSecondButton(<IconButton onClick={() => {
            setDetailOpen(!detailOpen);
        }} sx={{ position: 'absolute', right: 0, top: 4 }}>
            {detailOpen ? <Close /> : <Info />}
        </IconButton>);
    }, [t, setModuleSecondButton, setDetailOpen, detailOpen]);

    return (
        <div>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid lightgray", borderTop: "1px solid lightgray", bgcolor: "#FFC600", padding: 1 }}>
                <Stack direction="row" alignItems={'center'} spacing={1}>
                    <CalendarMonth fontSize='small' />
                    <Typography variant="body1" sx={{ color: "black" }}>{t('to')}{': '}{request.datetimeTo?.toLocaleDateString(i18n.language)}</Typography>
                </Stack>
                <Stack direction="row" alignItems={'center'} spacing={1} pr={2}>
                    <Person fontSize='small' />
                    <Typography variant="body1" sx={{ color: "black" }}>{request.assignee ? request.assignee.name : ''}</Typography>
                </Stack>
                {/* <EmployeeList buildingId={requestLocal.buildingId!} selectedEmployeeId={requestLocal.assignee?.id} onEmployeeClick={(assign) =>
                    setRequestLocal(new RequestResponseWithBuildingDTO({ ...requestLocal, assignee: new AssigneeResponseDTO({ id: assign?.adminId!, name: assign?.name }) }))} /> */}
            </Box>
            {detailOpen && <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid lightgray", borderTop: "1px solid lightgray", bgcolor: "#FFC600", padding: 1 }}>
                <Typography variant="body1" sx={{ color: "black" }}>{request.description ? request.description : t('withoutDescription')}</Typography>
            </Box>}
            {detailOpen && <Box sx={{ borderBottom: "1px solid lightgray", borderTop: "1px solid lightgray", bgcolor: "#FFC600", padding: 1 }}>
                <Typography variant="body2" sx={{ color: "black" }}>{t('Created')}{' '}<strong>{request.datetime?.toLocaleDateString(i18n.language)}</strong></Typography>
                <Typography variant="body2" sx={{ color: "black" }}>{t('Pro')}{' '}<strong>{request.buildingName ? request.buildingName : ''}</strong></Typography>
            </Box>}
            {detailOpen && request.assignee && request.assignee.id === employeeInfo?.adminUserId && request.state !== TodoState.RESOLVED && <Box
                sx={{
                    borderBottom: "1px solid lightgray",
                    borderTop: "1px solid lightgray",
                    color: "#FFC600",
                    padding: 1,
                    bgcolor: '#050505',
                    display: 'flex', // Ensures that the children align properly
                    alignItems: 'center', // Centers items vertically
                    justifyContent: 'center' // Centers items horizontally
                }}
            >
                <Button
                    fullWidth // Makes the button fill the full width of the parent Box
                    color="primary"
                    onClick={() => {
                        authorizedMobileEmployeeApi
                            .setRequestStateEmployeeMobile(
                                new SetRequestStateEmployeeMobileRequest({
                                    requestId: request.id,
                                    state: (request.state as number) + 1,
                                })
                            )
                            .then((res) => {
                                setRequest({
                                    ...request,
                                    state: (request.state as number) + 1,
                                    init: request.init,
                                    toJSON: request.toJSON,
                                });
                            });
                    }}
                    sx={{
                        height: '100%', // Ensures the button fills the height of the parent Box
                        display: 'flex',
                        alignItems: 'center', // Centers the content vertically within the button
                        justifyContent: 'center', // Centers the content horizontally within the button
                        textTransform: 'none', // Keeps the text as is, without converting to uppercase
                    }}
                >
                    <Typography color="#FFC600">
                        {request.state === TodoState.NEW
                            ? t('markAsInProgress').toUpperCase()
                            : (request.state === TodoState.ACTIVE ? t('markAsDone').toUpperCase() : '')}
                    </Typography>
                </Button>
            </Box>}
        </div>
    );
};

export default MobileRequestItemUpperMenu;